module.exports = __webpack_public_path__ + "img/laboratorio2_3-4_512.e8962f11.webp";